import type { ReactNode } from "react";

type PaperItemProps = {
  testId?: string;
  translate?: string;
  text?: string | number | ReactNode;
  textStyles?: string;
  wrapperStyle?: string;
  tranStyle?: string;
  translateEl?: ReactNode;
  labelClassName?: string;
  valueClassName?: string;
};

const PaperItem: React.FC<PaperItemProps> = ({
  wrapperStyle,
  tranStyle,
  translate,
  text,
  textStyles,
  translateEl,
  testId,
  labelClassName,
  valueClassName,
}) => (
  <div className={`flex w-full mt-3 mb-3 ${wrapperStyle}`}>
    {!translateEl ? (
      <span
        className={`${labelClassName ?? "w-1/2"} ${tranStyle} `}
        data-testid={`${testId}-label`}
        style={{ whiteSpace: "pre-line" }}
      >
        {translate}
      </span>
    ) : null}
    {translateEl}
    <span
      className={`${valueClassName ?? "w-1/2"} ${textStyles}`}
      data-testid={`${testId}-value`}
      style={{ whiteSpace: "pre-line", wordBreak: "break-word" }}
    >
      {text}
    </span>
  </div>
);

export default PaperItem;
